/**
 *
 */
export var MappingMode;
(function (MappingMode) {
    /**
     *
     */
    MappingMode[MappingMode["LINEAR"] = 0] = "LINEAR";
    /**
     *
     */
    MappingMode[MappingMode["RADIAL"] = 1] = "RADIAL";
})(MappingMode || (MappingMode = {}));
